module.exports = __webpack_public_path__ + "img/32.dd5e703e.png";